<script setup>
import Toggle from '@forms/Toggle.vue'
import { ref, watch } from 'vue'
import { http } from '@modules/useHttp'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  status: {
    type: Number,
    required: true,
  },
})

const isWeekly = ref(props.status === 1)

watch(() => isWeekly.value, async (weekly_rate) => {
  await http().patch(`/slw/${props.id}/weekly-rate`, { weekly_rate })
  window.location.reload()
})
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-x-2 tw-text-xs tw-font-medium">
    <Toggle v-model="isWeekly" size="sm" />

    <div v-if="isWeekly" class="tw-text-accent-100">
      Per Week
    </div>
    <div v-else class="tw-text-gray-500">
      Per Night
    </div>
  </div>
</template>
